<div class="faq-side">
  <mat-accordion>
    @for (faq of faqs; track faq) {
      <mat-expansion-panel style="line-height: 1.1;">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span style="font-size: 14px;font-weight: 600;line-height: 1.2;margin-right: 4px;">{{faq.question}}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <span style="color: #5E5E5E">{{faq.answer}}</span>
        <div class="btns-wrapper">
          @for (element of faq.ui_elements; track element) {
            <a href="javascript:void(0);" class="action-btn" (click)="openChat(faq)">
              <img src="{{ DEPLOY_URL }}/assets/images/message.svg" />
              <span >{{element.label}}</span>
            </a>
          }
        </div>
      </mat-expansion-panel>
    }
  </mat-accordion>
</div>

